"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _ANGFilters_assetTypesConfiguration, _ANGFilters_query, _ANGFilters_options;
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCustomFieldFilter = exports.parseQuery = void 0;
const memoize_one_1 = __importDefault(require("memoize-one"));
const queryParserUtils_1 = __importDefault(require("@mulesoft/exchange-commons/src/utils/queryParserUtils"));
const utils = __importStar(require("../utils"));
const constants = __importStar(require("./constants"));
const multiFilters = [
    'type',
    'category',
    'organizationId',
    'tag',
    'status',
    'field',
    'sharedWithMe'
];
const FILTER_REGEX = /^([^:]+):(.*):([^:\d]+)(?::(\d+))?$/;
const { parseNode } = (0, queryParserUtils_1.default)();
const getAsANGQuery = (0, memoize_one_1.default)((query, assetTypesConfiguration, options) => {
    var _a, _b;
    // eslint-disable-next-line no-underscore-dangle
    const internalANGQuery = query._angQuery;
    if (internalANGQuery) {
        return internalANGQuery;
    }
    const angQuery = {
        search: query.search ? query.search : undefined
    };
    if ((_a = query.sharedWithMe) === null || _a === void 0 ? void 0 : _a.length) {
        angQuery.sharedWithMe =
            ((_b = query.sharedWithMe) === null || _b === void 0 ? void 0 : _b[0]) === 'true' ? true : undefined;
    }
    angQuery.type = utils.getANGTypes(query.type, assetTypesConfiguration, options.fixedTypes);
    angQuery.category = query.category;
    angQuery.organizationId = query.organizationId;
    angQuery.tag = query.tag;
    angQuery.status = query.status;
    angQuery.field = query.field;
    return angQuery;
});
const getAsANGState = (0, memoize_one_1.default)((query, assetTypesConfiguration, options = {}) => {
    // eslint-disable-next-line no-underscore-dangle
    const internalANGState = query._angState;
    if (internalANGState) {
        return internalANGState;
    }
    const angState = {
        query: query.search,
        filters: {},
        customFilters: {}
    };
    angState.filters[constants.TYPE_KEY] = utils.getANGTypes(query.type, assetTypesConfiguration, options.fixedTypes);
    angState.filters[constants.CATEGORIES_KEY] = query.category;
    angState.filters[constants.ORGANIZATION_KEY] = query.organizationId;
    angState.filters[constants.TAGS_KEY] = query.tag;
    angState.filters[constants.STATUS_KEY] = query.status;
    angState.filters[constants.SHARED_WITH_ME_KEY] = query.sharedWithMe;
    angState.customFilters[constants.CUSTOM_FIELDS_FILTER_KEY] = [
        { key: constants.CUSTOM_FIELDS_KEY, values: query.field }
    ];
    return angState;
});
const hasQuery = (0, memoize_one_1.default)((query = {}) => !!query.search ||
    multiFilters.some((key) => utils.convertToArray(query[key]).length > 0));
function getTypes(angState, assetTypesConfiguration) {
    const angTypes = angState.filters[constants.TYPE_KEY];
    if (!angTypes) {
        return [];
    }
    return Object.keys(assetTypesConfiguration).filter((typeKey) => {
        if (typeKey === 'default') {
            return false;
        }
        const type = assetTypesConfiguration[typeKey];
        return angTypes.some((selectedType) => selectedType === type.angType);
    });
}
const parseQuery = (query) => {
    var _a;
    const parsedQuery = parseNode(query);
    const search = (_a = parsedQuery.query) !== null && _a !== void 0 ? _a : '';
    const tags = parsedQuery.tags
        .filter((tag) => tag.type === 'label')
        .map((tag) => tag.value);
    const categories = parsedQuery.tags
        .filter((tag) => tag.type === 'category')
        .map((category) => `${category.key}:${category.value}`);
    return {
        search,
        tag: tags,
        category: categories
    };
};
exports.parseQuery = parseQuery;
/**
 * Parse the given custom field filter
 *
 * @param {String} filter The filter with the structure name:value:operator:identifier
 * @returns {Object}
 */
const parseCustomFieldFilter = (filter) => {
    const matches = filter.match(FILTER_REGEX) || [];
    const [, key, value, operator, identifier] = matches;
    return { key, value, operator, identifier };
};
exports.parseCustomFieldFilter = parseCustomFieldFilter;
const getArraySnapshot = (array) => {
    return (array !== null && array !== void 0 ? array : [])
        .sort()
        .filter((value) => value)
        .join('\t');
};
/** Gets a snapshot as a string of the current filters, useful to compare two different ANGFilters instances */
const getFilterSnapshot = (filters) => {
    var _a, _b;
    const query = filters.getAsANGQuery();
    const arrayFilters = [
        query.category,
        query.field,
        query.organizationId,
        query.status,
        query.tag,
        query.type
    ].map(getArraySnapshot);
    return [
        ...arrayFilters,
        (_a = query.search) !== null && _a !== void 0 ? _a : '',
        (_b = query.sharedWithMe) !== null && _b !== void 0 ? _b : false
    ].join('\n');
};
const emptyQuery = Object.freeze({
    search: '',
    type: [],
    category: [],
    organizationId: [],
    tag: [],
    status: [],
    sharedWithMe: [],
    field: []
});
class ANGFilters {
    static compare(a, b) {
        return getFilterSnapshot(a) === getFilterSnapshot(b);
    }
    constructor(query, assetTypesConfiguration = {}, options) {
        _ANGFilters_assetTypesConfiguration.set(this, void 0);
        _ANGFilters_query.set(this, void 0);
        _ANGFilters_options.set(this, void 0);
        this.getQuery = () => __classPrivateFieldGet(this, _ANGFilters_query, "f");
        this.hasQuery = () => hasQuery(__classPrivateFieldGet(this, _ANGFilters_query, "f"));
        this.getAsANGState = () => {
            return getAsANGState(__classPrivateFieldGet(this, _ANGFilters_query, "f"), __classPrivateFieldGet(this, _ANGFilters_assetTypesConfiguration, "f"), __classPrivateFieldGet(this, _ANGFilters_options, "f"));
        };
        this.getAsANGQuery = () => getAsANGQuery(__classPrivateFieldGet(this, _ANGFilters_query, "f"), __classPrivateFieldGet(this, _ANGFilters_assetTypesConfiguration, "f"), __classPrivateFieldGet(this, _ANGFilters_options, "f"));
        if (typeof query.sharedWithMe === 'boolean') {
            __classPrivateFieldSet(this, _ANGFilters_query, Object.assign(Object.assign(Object.assign({}, emptyQuery), query), { sharedWithMe: [query.sharedWithMe.toString()] }), "f");
        }
        else {
            __classPrivateFieldSet(this, _ANGFilters_query, Object.assign(Object.assign({}, emptyQuery), query), "f");
        }
        __classPrivateFieldSet(this, _ANGFilters_assetTypesConfiguration, assetTypesConfiguration, "f");
        __classPrivateFieldSet(this, _ANGFilters_options, options !== null && options !== void 0 ? options : {}, "f");
    }
}
_ANGFilters_assetTypesConfiguration = new WeakMap(), _ANGFilters_query = new WeakMap(), _ANGFilters_options = new WeakMap();
ANGFilters.createEmptyState = (0, memoize_one_1.default)((assetTypesConfiguration, options = {}) => {
    return new ANGFilters(emptyQuery, assetTypesConfiguration, options);
});
ANGFilters.buildFromANGState = (0, memoize_one_1.default)((angState, assetTypesConfiguration, options = {}) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const query = {
        search: (_a = angState.query) !== null && _a !== void 0 ? _a : '',
        type: getTypes(angState, assetTypesConfiguration),
        category: (_b = angState.filters[constants.CATEGORIES_KEY]) !== null && _b !== void 0 ? _b : [],
        organizationId: (_c = angState.filters[constants.ORGANIZATION_KEY]) !== null && _c !== void 0 ? _c : [],
        status: (_d = angState.filters[constants.STATUS_KEY]) !== null && _d !== void 0 ? _d : [],
        tag: (_e = angState.filters[constants.TAGS_KEY]) !== null && _e !== void 0 ? _e : [],
        sharedWithMe: angState.filters[constants.SHARED_WITH_ME_KEY] || [],
        field: (_j = (_h = (_g = (_f = angState.customFilters) === null || _f === void 0 ? void 0 : _f[constants.CUSTOM_FIELDS_FILTER_KEY]) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.values) !== null && _j !== void 0 ? _j : [],
        _angState: angState
    };
    return new ANGFilters(query, assetTypesConfiguration, options);
});
ANGFilters.buildFromANGQuery = (0, memoize_one_1.default)((angQuery, assetTypesConfiguration, options = {}) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const filtersQuery = {
        search: (_a = angQuery.search) !== null && _a !== void 0 ? _a : '',
        type: (_b = angQuery.type) !== null && _b !== void 0 ? _b : [],
        category: (_c = angQuery.category) !== null && _c !== void 0 ? _c : [],
        organizationId: (_d = angQuery.organizationId) !== null && _d !== void 0 ? _d : [],
        tag: (_e = angQuery.tag) !== null && _e !== void 0 ? _e : [],
        status: (_f = angQuery.status) !== null && _f !== void 0 ? _f : [],
        sharedWithMe: angQuery.sharedWithMe ? ['true'] : [],
        field: (_g = angQuery.field) !== null && _g !== void 0 ? _g : [],
        _angQuery: angQuery
    };
    return new ANGFilters(filtersQuery, assetTypesConfiguration, options);
});
exports.default = ANGFilters;
